/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.0.3.0 (NJsonSchema v10.0.21.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import * as moment from 'moment';
export class ServiceProxy {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:3000/api";
    }


    /**
     * Get active codes percent
     * @return successful operation
     */
    getActiveCodesPercent(): Promise<GetActiveCodesPercentResult> {
        let url_ = this.baseUrl + "/admin/stats/activated-code-percentage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActiveCodesPercent(_response);
        });
    }

    /**
     * Get active codes percent
     * @return successful operation
     */
    getDoneExePercent(userId: string): Promise<GetActiveCodesPercentResult> {
        let url_ = this.baseUrl + "/admin/stats/done-exercises-percentage/{admin_book_id}";
        url_ = url_.replace("{admin_book_id}", userId);
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActiveCodesPercent(_response);
        });
    }

    /**
     * Get active codes percent
     * @return successful operation
     */
    getCorrectExePercent(userId: string): Promise<GetActiveCodesPercentResult> {
        let url_ = this.baseUrl + "/admin/stats/correct-exercises-percentage/{admin_book_id}";
        url_ = url_.replace("{admin_book_id}", userId);
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActiveCodesPercent(_response);
        });
    }

    protected processGetActiveCodesPercent(response: Response): Promise<GetActiveCodesPercentResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                const jsonData = JSON.parse(_responseText)
                result200 = _responseText === "" ? null : <GetActiveCodesPercentResult>JSON.parse(JSON.stringify(jsonData.data), this.jsonParseReviver);
                
                return result200;

            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetActiveCodesPercentResult>(<any>null);
    }

    /**
     * Get active codes percent
     * @return successful operation
     */
    getBookWithHighestActiveCodes(): Promise<GetBookWithHighestActiveCodesResult> {
        let url_ = this.baseUrl + "/analytics/customs/book-with-highest-active-codes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBookWithHighestActiveCodes(_response);
        });
    }

    protected processGetBookWithHighestActiveCodes(response: Response): Promise<GetBookWithHighestActiveCodesResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <GetBookWithHighestActiveCodesResult>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetBookWithHighestActiveCodesResult>(<any>null);
    }

    /**
     * Get active codes percent
     * @return successful operation
     */
    getTop10Books(): Promise<GetBooksResult> {
        let url_ = this.baseUrl + "/admin/books/top-books";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTop10Books(_response);
        });
    }

    protected processGetTop10Books(response: Response): Promise<GetBooksResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                const jsonData = JSON.parse(_responseText)
                result200 = _responseText === "" ? null : <GetBooksResult>JSON.parse(JSON.stringify(jsonData), this.jsonParseReviver);
                return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetBooksResult>(<any>null);
    }

    /**
     * Get access code by userId
     * @param book (optional) Book filter
     * @param type (optional) Book type filter
     * @param classes (optional) Class filter
     * @param hasUser (optional) Has user filter
     * @param createdFrom (optional) Created date filter
     * @param createdTo (optional) Create date filter
     * @return successful operation
     */
    exportAccessCodesExcel(book: string | undefined, type: string | undefined, classes: number | undefined, hasUser: boolean | undefined, createdFrom: number | undefined, createdTo: number | undefined): Promise<ExportExcelResult> {
        let url_ = this.baseUrl + "/access-codes/customs/export-excel?";
        if (book === null)
            throw new Error("The parameter 'book' cannot be null.");
        else if (book !== undefined)
            url_ += "book=" + encodeURIComponent("" + book) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (classes === null)
            throw new Error("The parameter 'classes' cannot be null.");
        else if (classes !== undefined)
            url_ += "classes=" + encodeURIComponent("" + classes) + "&";
        if (hasUser === null)
            throw new Error("The parameter 'hasUser' cannot be null.");
        else if (hasUser !== undefined)
            url_ += "hasUser=" + encodeURIComponent("" + hasUser) + "&";
        if (createdFrom === null)
            throw new Error("The parameter 'createdFrom' cannot be null.");
        else if (createdFrom !== undefined)
            url_ += "createdFrom=" + encodeURIComponent("" + createdFrom) + "&";
        if (createdTo === null)
            throw new Error("The parameter 'createdTo' cannot be null.");
        else if (createdTo !== undefined)
            url_ += "createdTo=" + encodeURIComponent("" + createdTo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportAccessCodesExcel(_response);
        });
    }

    protected processExportAccessCodesExcel(response: Response): Promise<ExportExcelResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ExportExcelResult>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExportExcelResult>(<any>null);
    }

    /**
     * Check if server is creat codes
     * @return successful operation
     */
    checkIsCreateCodes(): Promise<CheckCreateCodesResult> {
        let url_ = this.baseUrl + "/access-codes/customs/is-creating-codes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckIsCreateCodes(_response);
        });
    }

    protected processCheckIsCreateCodes(response: Response): Promise<CheckCreateCodesResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <CheckCreateCodesResult>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CheckCreateCodesResult>(<any>null);
    }

    /**
     * Get access code by userId
     * @param size (optional) number of records returned
     * @param pageNumber (optional) current page number
     * @param sortBy (optional) sort field
     * @param before (optional) before token
     * @param after (optional) after token
     * @return successful operation
     */
    getAccessCodesByUser(size: number | undefined, pageNumber: number | undefined, sortBy: string | undefined, userId: string | undefined): Promise<FindAccessCodesResult> {
        let url_ = this.baseUrl + "/admin/book-codes/look-up/access-code/users/{userId}?";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (userId === null)
            throw new Error("The parameter 'before' cannot be null.");
        else if (userId !== undefined)
            url_ = url_.replace('{userId}',userId);
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAccessCodesByUser(_response);
        });
    }

    protected processGetAccessCodesByUser(response: Response): Promise<FindAccessCodesResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                const jsonData = JSON.parse(_responseText)
                result200 = _responseText === "" ? null : <FindAccessCodesResult>JSON.parse(JSON.stringify(jsonData.data), this.jsonParseReviver);
                
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FindAccessCodesResult>(<any>null);
    }

    /**
     * Submit access code
     * @return successful operation
     */
    submitAccessCode(body: SubmitAccessCodeBody): Promise<MessageResult> {
        let url_ = this.baseUrl + "/admin/book-codes/activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubmitAccessCode(_response);
        });
    }

    protected processSubmitAccessCode(response: Response): Promise<MessageResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: MessageResult = {
                    message:''
                };
                const dataJson  = JSON.parse(_responseText)
                if(dataJson.data){
                    result200.message = 'success'
                    return result200;
                } else{
                    result200.message = dataJson.status
                    return result200;
                }
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === "" ? null : <MessageResult>JSON.parse(_responseText, this.jsonParseReviver);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessageResult>(<any>null);
    }

    /**
     * Delete access code
     * @param accessCodeId Access code id
     * @return successful operation
     */
    deleteAccessCode(accessCodeId: string): Promise<void> {
        let url_ = this.baseUrl + "/access-codes/{accessCodeId}";
        if (accessCodeId === undefined || accessCodeId === null)
            throw new Error("The parameter 'accessCodeId' must be defined.");
        url_ = url_.replace("{accessCodeId}", encodeURIComponent("" + accessCodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAccessCode(_response);
        });
    }

    protected processDeleteAccessCode(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Create access code
     * @return successful operation
     */
    createAccessCode(body: CreateAccessCodeBody): Promise<CreateAccessCodeResult> {
        let url_ = this.baseUrl + "/admin/book-codes/generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateAccessCode(_response);
        });
    }

    protected processCreateAccessCode(response: Response): Promise<CreateAccessCodeResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                
                result200 = _responseText === "" ? null : <CreateAccessCodeResult>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === "" ? null : <CreateAccessCodeResult>JSON.parse(_responseText, this.jsonParseReviver);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAccessCodeResult>(<any>null);
    }

    /**
     * Get access code by userId
     * @param book (optional) Book filter
     * @param type (optional) Book type filter
     * @param classes (optional) Class filter
     * @param hasUser (optional) Has user filter
     * @param createdFrom (optional) Created date filter
     * @param createdTo (optional) Create date filter
     * @param size (optional) number of records returned
     * @param sortBy (optional) sort field
     * @param before (optional) before token
     * @param after (optional) after token
     * @return successful operation
     */
    getAccessCode(book: string | undefined, category: string | undefined, grade: number | undefined,is_activated: boolean | undefined, size: number | undefined,page: number | undefined ): Promise<FindAccessCodesResult> {
        let url_ = this.baseUrl + "/admin/book-codes?";
        if (book === null)
            throw new Error("The parameter 'book' cannot be null.");
        else if (book !== undefined)
            url_ += "book=" + encodeURIComponent("" + book) + "&";
        if (category === null)
            throw new Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        if (is_activated === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (is_activated !== undefined)
            url_ += "is_activated=" + encodeURIComponent("" + is_activated) + "&";
        if (grade === null)
            throw new Error("The parameter 'grade' cannot be null.");
        else if (grade !== undefined)
            url_ += "grade=" + encodeURIComponent("" + grade) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (page === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAccessCode(_response);
        });
    }

    protected processGetAccessCode(response: Response): Promise<FindAccessCodesResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                const jsonData = JSON.parse(_responseText)
                result200 = _responseText === "" ? null : <FindAccessCodesResult>JSON.parse(JSON.stringify(jsonData.data), this.jsonParseReviver);
                
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FindAccessCodesResult>(<any>null);
    }

    /**
     * Get provinces
     * @param province Province filter
     * @return successful operation
     */
    // getDistricts(province: number): Promise<GetDistrictsResult> {
    //     let url_ = this.baseUrl + "/auth/customs/get-districts?";
    //     if (province === undefined || province === null)
    //         throw new Error("The parameter 'province' must be defined and cannot be null.");
    //     else
    //         url_ += "province=" + encodeURIComponent("" + province) + "&";
    //     url_ = url_.replace(/[?&]$/, "");

    //     let options_ = <RequestInit>{
    //         method: "GET",
    //         headers: {
    //             "Accept": "application/json"
    //         }
    //     };

    //     return this.http.fetch(url_, options_).then((_response: Response) => {
    //         return this.processGetDistricts(_response);
    //     });
    // }

    // protected processGetDistricts(response: Response): Promise<GetDistrictsResult> {
    //     const status = response.status;
    //     let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
    //     if (status === 200) {
    //         return response.text().then((_responseText) => {
    //             let result200: any = null;
    //             result200 = _responseText === "" ? null : <GetDistrictsResult>JSON.parse(_responseText, this.jsonParseReviver);
    //             return result200;
    //         });
    //     } else if (status === 201) {
    //         return response.text().then((_responseText) => {
    //             let result201: any = null;
    //             result201 = _responseText === "" ? null : <GetDistrictsResult>JSON.parse(_responseText, this.jsonParseReviver);
    //             return result201;
    //         });
    //     } else if (status === 400) {
    //         return response.text().then((_responseText) => {
    //             return throwException("A server error occurred.", status, _responseText, _headers);
    //         });
    //     } else if (status === 401) {
    //         return response.text().then((_responseText) => {
    //             return throwException("A server error occurred.", status, _responseText, _headers);
    //         });
    //     } else if (status === 500) {
    //         return response.text().then((_responseText) => {
    //             return throwException("A server error occurred.", status, _responseText, _headers);
    //         });
    //     } else if (status !== 200 && status !== 204) {
    //         return response.text().then((_responseText) => {
    //             return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    //         });
    //     }
    //     return Promise.resolve<GetDistrictsResult>(<any>null);
    // }

    /**
     * Get provinces
     * @return successful operation
     */
    // getProvinces(): Promise<GetProvincesResult> {
    //     let url_ = this.baseUrl + "/auth/customs/get-provinces";
    //     url_ = url_.replace(/[?&]$/, "");

    //     let options_ = <RequestInit>{
    //         method: "GET",
    //         headers: {
    //             "Accept": "application/json"
    //         }
    //     };

    //     return this.http.fetch(url_, options_).then((_response: Response) => {
    //         return this.processGetProvinces(_response);
    //     });
    // }

    // protected processGetProvinces(response: Response): Promise<GetProvincesResult> {
    //     const status = response.status;
    //     let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
    //     if (status === 200) {
    //         return response.text().then((_responseText) => {
    //             let result200: any = null;
    //             result200 = _responseText === "" ? null : <GetProvincesResult>JSON.parse(_responseText, this.jsonParseReviver);
    //             return result200;
    //         });
    //     } else if (status === 201) {
    //         return response.text().then((_responseText) => {
    //             let result201: any = null;
    //             result201 = _responseText === "" ? null : <GetProvincesResult>JSON.parse(_responseText, this.jsonParseReviver);
    //             return result201;
    //         });
    //     } else if (status === 400) {
    //         return response.text().then((_responseText) => {
    //             return throwException("A server error occurred.", status, _responseText, _headers);
    //         });
    //     } else if (status === 401) {
    //         return response.text().then((_responseText) => {
    //             return throwException("A server error occurred.", status, _responseText, _headers);
    //         });
    //     } else if (status === 500) {
    //         return response.text().then((_responseText) => {
    //             return throwException("A server error occurred.", status, _responseText, _headers);
    //         });
    //     } else if (status !== 200 && status !== 204) {
    //         return response.text().then((_responseText) => {
    //             return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    //         });
    //     }
    //     return Promise.resolve<GetProvincesResult>(<any>null);
    // }

    /**
     * Get token
     * @param appToken (optional) appToken
     * @return successful operation
     */
    getToken(appToken: string | undefined): Promise<TokenResult> {
        let url_ = this.baseUrl + "/auth/customs/getToken?";
        if (appToken === null)
            throw new Error("The parameter 'appToken' cannot be null.");
        else if (appToken !== undefined)
            url_ += "appToken=" + encodeURIComponent("" + appToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetToken(_response);
        });
    }

    protected processGetToken(response: Response): Promise<TokenResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <TokenResult>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === "" ? null : <TokenResult>JSON.parse(_responseText, this.jsonParseReviver);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TokenResult>(<any>null);
    }

    /**
     * Change phone number
     * @return successful operation
     */
    updateLastLogin(body: UpdateLastLoginBody): Promise<void> {
        let url_ = this.baseUrl + "/auth/customs/update-last-login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateLastLogin(_response);
        });
    }

    protected processUpdateLastLogin(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Check phone number exist
     * @param phone Phone number
     * @return successful operation
     */
    checkphoneExist(phone: string): Promise<CheckphoneExistResult> {
        let url_ = this.baseUrl + "/auth/customs/check-phone-exist/{phone}";
        if (phone === undefined || phone === null)
            throw new Error("The parameter 'phone' must be defined.");
        url_ = url_.replace("{phone}", encodeURIComponent("" + phone));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckphoneExist(_response);
        });
    }

    protected processCheckphoneExist(response: Response): Promise<CheckphoneExistResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <CheckphoneExistResult>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CheckphoneExistResult>(<any>null);
    }

    /**
     * Logout user
     * @return successful operation
     */
    logoutUser(): Promise<void> {
        let url_ = this.baseUrl + "/auth/customs/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogoutUser(_response);
        });
    }

    protected processLogoutUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Login user
     * @return successful operation
     */
    loginUser(body: LoginUserPayload): Promise<LoginResult> {
        let url_ = this.baseUrl + "/auth/sign-in";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLoginUser(_response);
        });
    }

        /**
     * Login user
     * @return successful operation
     */
    loginAdminUser(body: LoginAdminUserPayload): Promise<LoginResult> {
        let url_ = this.baseUrl + "/auth/sign-in";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLoginUser(_response);
        });
    }

    protected processLoginUser(response: Response): Promise<LoginResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                const jsonData = JSON.parse(_responseText)
                if (jsonData.status === "UR0001" || jsonData.status === "UR0004") {
                    return throwException("A server error occurred.", status, _responseText, _headers);
                }
                if (jsonData.status === "UR0003") {
                    return throwException("A server error occurred.", status, _responseText, _headers);
                }
                result200 = <LoginResult>JSON.parse(JSON.stringify(jsonData.data), this.jsonParseReviver);
                localStorage.setItem('token', result200.access_token);
                localStorage.setItem('isVerify', `${jsonData.data.user.email_verified ? 1 : 0}`)
                return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === "" ? null : <LoginResult>JSON.parse(_responseText, this.jsonParseReviver);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginResult>(<any>null);
    }

    /**
     * Login user
     * @return successful operation
     */
    userForgotPassword(body: UserForgotPasswordPayload): Promise<LoginResult> {
        let url_ = this.baseUrl + "/auth/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processForgotPassword(_response);
        });
    }

    userForgotPasswordSMS(body: UserForgotPasswordPayloadSMS): Promise<LoginResult> {
        let url_ = this.baseUrl + "/auth/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: Response): Promise<LoginResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                const jsonData = JSON.parse(_responseText)
                if (jsonData.status === "UR0001") {
                    return throwException("A server error occurred.", status, _responseText, _headers);
                }
                if (jsonData.status === "UR0003") {
                    return throwException("A server error occurred.", status, _responseText, _headers);
                }
                if (jsonData.status === "UR0014") {
                    return throwException("A server error occurred.", status, _responseText, _headers);
                }
                if (jsonData.status === "UR0013") {
                    return throwException("A server error occurred.", status, _responseText, _headers);
                }
                result200 = <LoginResult>JSON.parse(JSON.stringify(jsonData.data), this.jsonParseReviver);
                return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === "" ? null : <LoginResult>JSON.parse(_responseText, this.jsonParseReviver);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginResult>(<any>null);
    }

    /**
     * change password
     * @return successful operation
     */
    userChangePassword(body: UserChangePasswordPayload): Promise<LoginResult> {
        let url_ = this.baseUrl + "/auth/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }
    userChangePasswordSMS(body: UserChangePasswordPayloadSMS): Promise<LoginResult> {
        let url_ = this.baseUrl + "/auth/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<LoginResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                const jsonData = JSON.parse(_responseText)
                if (jsonData.status === "UR0001") {
                    return throwException("A server error occurred.", status, _responseText, _headers);
                }
                if (jsonData.status === "UR0005") {
                    console.log(_responseText);
                    return throwException("A server error occurred.", status, _responseText, _headers);
                }
                result200 = <LoginResult>JSON.parse(JSON.stringify(jsonData.data), this.jsonParseReviver);
                return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === "" ? null : <LoginResult>JSON.parse(_responseText, this.jsonParseReviver);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginResult>(<any>null);
    }

    /**
     * Register user
     * @return successful operation
     */
    registerUser(body: RegisterUserPayload): Promise<void> {
        let url_ = this.baseUrl + "/auth/sign-up";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegisterUser(_response);
        });
    }

    protected processRegisterUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                const jsonData = JSON.parse(_responseText)
                if (jsonData.status === "UR0001") {
                    return throwException("A server error occurred.", status, _responseText, _headers);
                }
                if (jsonData.status === "UR0002") {
                    return throwException("A server error occurred.", status, _responseText, _headers);
                }
                if (jsonData.status === "UR0005") {
                    console.log(_responseText);
                    return throwException("A server error occurred.", status, _responseText, _headers);
                }
                if (jsonData.status === "UR0012") {
                    console.log(_responseText);
                    return throwException("A server error occurred.", status, _responseText, _headers);
                }
                result200 = <LoginResult>JSON.parse(JSON.stringify(jsonData.data), this.jsonParseReviver);
                return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Find permissions list of all modules
     * @return successful operation
     */
    findPermissions(): Promise<FindPermissionsResult> {
        let url_ = this.baseUrl + "/permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFindPermissions(_response);
        });
    }

    protected processFindPermissions(response: Response): Promise<FindPermissionsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <FindPermissionsResult>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FindPermissionsResult>(<any>null);
    }

    /**
     * Check role name exist
     * @param roleName roleName
     * @return successful operation
     */
    checkRoleNameExist(roleName: string): Promise<CheckRoleNameExistResult> {
        let url_ = this.baseUrl + "/roles/customs/check-name-exist/{roleName}";
        if (roleName === undefined || roleName === null)
            throw new Error("The parameter 'roleName' must be defined.");
        url_ = url_.replace("{roleName}", encodeURIComponent("" + roleName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckRoleNameExist(_response);
        });
    }

    protected processCheckRoleNameExist(response: Response): Promise<CheckRoleNameExistResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <CheckRoleNameExistResult>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CheckRoleNameExistResult>(<any>null);
    }

    /**
     * Find all roles
     * @return successful operation
     */
    getAllRoles(): Promise<GetAllRolesResult> {
        let url_ = this.baseUrl + "/roles/customs/get-all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllRoles(_response);
        });
    }

    protected processGetAllRoles(response: Response): Promise<GetAllRolesResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <GetAllRolesResult>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAllRolesResult>(<any>null);
    }

    /**
     * Find role by id
     * @param roleId roleId
     * @return successful operation
     */
    findRoleById(roleId: string): Promise<Role> {
        let url_ = this.baseUrl + "/roles/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFindRoleById(_response);
        });
    }

    protected processFindRoleById(response: Response): Promise<Role> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <Role>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Role>(<any>null);
    }

    /**
     * Update role
     * @param roleId roleId
     * @return successful operation
     */
    updateRole(roleId: string, body: Body): Promise<void> {
        let url_ = this.baseUrl + "/roles/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateRole(_response);
        });
    }

    protected processUpdateRole(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Find roles
     * @param search (optional) search
     * @param permissions (optional) filter by permissions
     * @param size number of records returned
     * @param sortBy sort field
     * @param before (optional) before token
     * @param after (optional) after token
     * @return successful operation
     */
    findRoles(search: string | undefined, permissions: string[] | undefined, size: number, sortBy: string, before: string | undefined, after: string | undefined): Promise<FindRolesResult> {
        let url_ = this.baseUrl + "/roles?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (permissions === null)
            throw new Error("The parameter 'permissions' cannot be null.");
        else if (permissions !== undefined)
            permissions && permissions.forEach(item => { url_ += "permissions=" + encodeURIComponent("" + item) + "&"; });
        if (size === undefined || size === null)
            throw new Error("The parameter 'size' must be defined and cannot be null.");
        else
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (sortBy === undefined || sortBy === null)
            throw new Error("The parameter 'sortBy' must be defined and cannot be null.");
        else
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (before === null)
            throw new Error("The parameter 'before' cannot be null.");
        else if (before !== undefined)
            url_ += "before=" + encodeURIComponent("" + before) + "&";
        if (after === null)
            throw new Error("The parameter 'after' cannot be null.");
        else if (after !== undefined)
            url_ += "after=" + encodeURIComponent("" + after) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFindRoles(_response);
        });
    }

    protected processFindRoles(response: Response): Promise<FindRolesResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <FindRolesResult>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FindRolesResult>(<any>null);
    }

    /**
     * Create role
     * @return successful operation
     */
    createRole(body: CreateRolePayload): Promise<Role> {
        let url_ = this.baseUrl + "/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateRole(_response);
        });
    }

    protected processCreateRole(response: Response): Promise<Role> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <Role>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === "" ? null : <Role>JSON.parse(_responseText, this.jsonParseReviver);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Role>(<any>null);
    }

    /**
     * Get profile
     * @return successful operation
     */
    getProfile(): Promise<User> {
        let url_ = this.baseUrl + "/profile";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProfile(_response);
        });
    }

    protected processGetProfile(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            
            return response.text().then((_responseText) => {
                let result200: any = null;
                const dataJson  = JSON.parse(_responseText)
                if (dataJson.status === "UR0015" || dataJson.status === "UR0016" || dataJson.status === 'UR0012') {
                    let keysToRemove = ["token", "isVerify", "i18nextLng", "read_notice", "persist:root"];

                    for (let index = 0; index < keysToRemove.length; index++) {
                        localStorage.removeItem(keysToRemove[index]);
                    }
                    return throwException("A server error occurred.", status, _responseText, _headers);
                }else{
                    result200 = _responseText === "" ? null : <User>JSON.parse(JSON.stringify(dataJson.data), this.jsonParseReviver);
                    return result200;
                }
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(<any>null);
    }

    /**
     * Update profile
     * @param userId userId
     * @return successful operation
     */
    updateProfile(userId: string, body: Body2): Promise<UpdatephoneResult> {
        let url_ = this.baseUrl + "/profiles/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateProfile(_response);
        });
    }

    protected processUpdateProfile(response: Response): Promise<UpdatephoneResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <UpdatephoneResult>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === "" ? null : <UpdatephoneResult>JSON.parse(_responseText, this.jsonParseReviver);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdatephoneResult>(<any>null);
    }

    /**
     * Find users
     * @param search (optional) search
     * @param roles (optional) filter by roles
     * @param province (optional) search
     * @param district (optional) search
     * @param size number of records returned
     * @param sortBy sort field
     * @param before (optional) before token
     * @param after (optional) after token
     * @return successful operation
     */
    findUsers(search: string | undefined, address: string | undefined, size: number,page: number, sortBy: string): Promise<FindUsersResult> {
        let url_ = this.baseUrl + "/users?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (address === null)
            throw new Error("The parameter 'province' cannot be null.");
        else if (address !== undefined)
            url_ += "address=" + encodeURIComponent("" + address) + "&";
        if (size === undefined || size === null)
            throw new Error("The parameter 'size' must be defined and cannot be null.");
        // else
        //     url_ += "size=" + encodeURIComponent("" + size) + "&";
        // if (sortBy === undefined || sortBy === null)
        //     throw new Error("The parameter 'sortBy' must be defined and cannot be null.");
        // else
        //     url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFindUsers(_response);
        });
    }

    protected processFindUsers(response: Response): Promise<FindUsersResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                const jsonData = JSON.parse(_responseText)
                result200 = _responseText === "" ? null : <FindUsersResult>JSON.parse(JSON.stringify(jsonData.data), this.jsonParseReviver);
                
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FindUsersResult>(<any>null);
    }

    /**
     * Create user
     * @return successful operation
     */
    createUser(body: RegisterUserPayload): Promise<User> {
        let url_ = this.baseUrl + "/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <User>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === "" ? null : <User>JSON.parse(_responseText, this.jsonParseReviver);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(<any>null);
    }

    /**
     * Find users
     * @param search (optional) search
     * @param roles (optional) filter by roles
     * @param province (optional) search
     * @param district (optional) search
     * @return successful operation
     */
    exportUsersExcel(search: string | undefined, roles: string[] | undefined, province: number | undefined, district: number | undefined): Promise<ExportExcelResult> {
        let url_ = this.baseUrl + "/users/customs/export-excel?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (roles === null)
            throw new Error("The parameter 'roles' cannot be null.");
        else if (roles !== undefined)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        if (province === null)
            throw new Error("The parameter 'province' cannot be null.");
        else if (province !== undefined)
            url_ += "province=" + encodeURIComponent("" + province) + "&";
        if (district === null)
            throw new Error("The parameter 'district' cannot be null.");
        else if (district !== undefined)
            url_ += "district=" + encodeURIComponent("" + district) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportUsersExcel(_response);
        });
    }

    protected processExportUsersExcel(response: Response): Promise<ExportExcelResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ExportExcelResult>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExportExcelResult>(<any>null);
    }

    /**
     * Find user by id
     * @param userId userId
     * @return successful operation
     */
    findUserById(userId: string): Promise<User> {
        let url_ = this.baseUrl + "/users/look-up?id={userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFindUserById(_response);
        });
    }

    protected processFindUserById(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                const jsonData = JSON.parse(_responseText)
                result200 = _responseText === "" ? null : <User>JSON.parse(JSON.stringify(jsonData.data), this.jsonParseReviver);
                
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(<any>null);
    }

    /**
     * Update user
     * @param userId userId
     * @return successful operation
     */
    updateUser(userId: string, body: UpdateUserPayload): Promise<User> {
        let url_ = this.baseUrl + "/admin/users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <User>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === "" ? null : <User>JSON.parse(_responseText, this.jsonParseReviver);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(<any>null);
    }

    /**
     * Get books
     * @param search (optional) search filter
     * @param grade (optional) grade filter
     * @param type (optional) book type query
     * @return successful operation
     */
    exportBooksExcel(search: string | undefined, grade: number | undefined, type: string | undefined): Promise<ExportExcelResult> {
        let url_ = this.baseUrl + "/books/customs/export-excel?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (grade === null)
            throw new Error("The parameter 'grade' cannot be null.");
        else if (grade !== undefined)
            url_ += "grade=" + encodeURIComponent("" + grade) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportBooksExcel(_response);
        });
    }

    protected processExportBooksExcel(response: Response): Promise<ExportExcelResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ExportExcelResult>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExportExcelResult>(<any>null);
    }

    /**
     * Delete book
     * @param bookId Book ID
     * @return successful operation
     */
    deleteBook(bookId: string): Promise<void> {
        let url_ = this.baseUrl + "/books/{bookId}";
        if (bookId === undefined || bookId === null)
            throw new Error("The parameter 'bookId' must be defined.");
        url_ = url_.replace("{bookId}", encodeURIComponent("" + bookId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteBook(_response);
        });
    }

    deleteAdminsBook(bookId: string): Promise<void> {
        let url_ = this.baseUrl + "/admin/books/{bookId}";
        if (bookId === undefined || bookId === null)
            throw new Error("The parameter 'bookId' must be defined.");
        url_ = url_.replace("{bookId}", encodeURIComponent("" + bookId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteBook(_response);
        });
    }

    deleteRecommendBook(bookId: string): Promise<void> {
        let url_ = this.baseUrl + "/admin/book-recommends/{bookId}";
        if (bookId === undefined || bookId === null)
            throw new Error("The parameter 'bookId' must be defined.");
        url_ = url_.replace("{bookId}", encodeURIComponent("" + bookId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteBook(_response);
        });
    }

    protected processDeleteBook(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Update book
     * @param bookId Book ID
     * @return successful operation
     */
    getBookById(bookId: string): Promise<Book> {
        let url_ = this.baseUrl + "/books/{bookId}";
        if (bookId === undefined || bookId === null)
            throw new Error("The parameter 'bookId' must be defined.");
        url_ = url_.replace("{bookId}", encodeURIComponent("" + bookId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBookById(_response);
        });
    }
    getAdminBookById(bookId: string): Promise<Book> {
        let url_ = this.baseUrl + "/admin/books/look-up/{bookId}";
        if (bookId === undefined || bookId === null)
            throw new Error("The parameter 'bookId' must be defined.");
        url_ = url_.replace("{bookId}", encodeURIComponent("" + bookId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBookById(_response);
        });
    }

    getRecommendBookById(bookId: string): Promise<BookRecommend> {
        let url_ = this.baseUrl + "/admin/book-recommends/look-up/id/{bookId}";
        if (bookId === undefined || bookId === null)
            throw new Error("The parameter 'bookId' must be defined.");
        url_ = url_.replace("{bookId}", encodeURIComponent("" + bookId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRecommendBookById(_response);
        });
    }

    protected processGetRecommendBookById(response: Response): Promise<BookRecommend> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                const jsonData = JSON.parse(_responseText)
                result200 = _responseText === "" ? null : <BookRecommend>JSON.parse(JSON.stringify(jsonData.data), this.jsonParseReviver);
                
                return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === "" ? null : <BookRecommend>JSON.parse(_responseText, this.jsonParseReviver);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BookRecommend>(<any>null);
    }

    protected processGetBookById(response: Response): Promise<Book> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <Book>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === "" ? null : <Book>JSON.parse(_responseText, this.jsonParseReviver);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Book>(<any>null);
    }

        /**
     * Update book
     * @param bookId Book ID
     * @return successful operation
     */
    updateRecommendBook( body: CreateRecommendBookBody): Promise<BookRecommend> {
        let url_ = this.baseUrl + "/admin/book-recommends";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateRecommendBook(_response);
        });
    }

    /**
     * Update book
     * @param bookId Book ID
     * @return successful operation
     */
    updateBook(bookId: string, body: UpdateBookBody): Promise<Book> {
        let url_ = this.baseUrl + "/books/{bookId}";
        if (bookId === undefined || bookId === null)
            throw new Error("The parameter 'bookId' must be defined.");
        url_ = url_.replace("{bookId}", encodeURIComponent("" + bookId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateBook(_response);
        });
    }

    protected processUpdateRecommendBook(response: Response): Promise<BookRecommend> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <BookRecommend>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === "" ? null : <BookRecommend>JSON.parse(_responseText, this.jsonParseReviver);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BookRecommend>(<any>null);
    }

    protected processUpdateBook(response: Response): Promise<Book> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <Book>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === "" ? null : <Book>JSON.parse(_responseText, this.jsonParseReviver);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Book>(<any>null);
    }

        /**
     * Create recommend book
     * @return successful operation
     */
    createRecommendBook(body: CreateRecommendBookBody): Promise<BookRecommend> {
        let url_ = this.baseUrl + "/admin/book-recommends";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateRecommendBook(_response);
        });
    }

    protected processCreateRecommendBook(response: Response): Promise<BookRecommend> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                const jsonData = JSON.parse(_responseText)
                
                result200 = _responseText === "" ?  null : <BookRecommend>JSON.parse(JSON.stringify(jsonData.data), this.jsonParseReviver);
                
                return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === "" ? null : <Book>JSON.parse(_responseText, this.jsonParseReviver);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BookRecommend>(<any>null);
    }

    /**
     * Create book
     * @return successful operation
     */
    createBook(body: CreateBookBody): Promise<Book> {
        let url_ = this.baseUrl + "/admin/books";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateBook(_response);
        });
    }

    protected processCreateBook(response: Response): Promise<Book> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <Book>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === "" ? null : <Book>JSON.parse(_responseText, this.jsonParseReviver);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Book>(<any>null);
    }

    /**
     * Get books
     * @param search (optional) search filter
     * @param grade (optional) grade filter
     * @param type (optional) book type query
     * @param size (optional) number of records returned
     * @param pageNumber (optional) current page number
     * @param sortBy (optional) sort field
     * @param before (optional) before token
     * @param after (optional) after token
     * @return successful operation
     */
    getBooks(title: string | undefined, grade: number | undefined, type: string | undefined, size: number | undefined, page: number | undefined, sortBy: string | undefined): Promise<GetBooksResult> {
        let url_ = this.baseUrl + "/books?";
        if (title === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (title !== undefined)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        if (grade === null)
            throw new Error("The parameter 'grade' cannot be null.");
        else if (grade !== undefined)
            url_ += "grade=" + encodeURIComponent("" + grade) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (page === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";

        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBooks(_response);
        });
    }

    getRecommendBooks(search: string | undefined, grade: number | undefined, type: string | undefined, size: number | undefined, page: number | undefined, sortBy: string | undefined): Promise<GetBooksResult> {
        let url_ = this.baseUrl + "/admin/book-recommends?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "title=" + encodeURIComponent("" + search) + "&";
        if (grade === null)
            throw new Error("The parameter 'grade' cannot be null.");
        else if (grade !== undefined)
            url_ += "grade=" + encodeURIComponent("" + grade) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (page === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";

        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBooks(_response);
        });
    }

    getRecommendBooksById(bookId: string | undefined,size: number | undefined, page: number | undefined): Promise<GetBooksResult> {
        let url_ = this.baseUrl + "/admin/book-recommends/look-up/admin-book/{bookid}?";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (page === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (bookId === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (bookId !== undefined)
            url_ = url_.replace("{bookid}", bookId);
        
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBooks(_response);
        });
    }

    getAdminsBooks(search: string | undefined, grade: number | undefined, type: string | undefined, size: number | undefined, page: number | undefined, sortBy: string | undefined): Promise<GetBooksResult> {
        let url_ = this.baseUrl + "/admin/books?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "title=" + encodeURIComponent("" + search) + "&";
        if (grade === null)
            throw new Error("The parameter 'grade' cannot be null.");
        else if (grade !== undefined)
            url_ += "grade=" + encodeURIComponent("" + grade) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (page === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";

        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBooks(_response);
        });
    }

    getUsingBooks(search:string | undefined,size: number | undefined, page: number | undefined, userId: string | undefined): Promise<GetBooksResult> {
        let url_ = this.baseUrl + "/admin/book-codes/look-up/access-code/users/{userId}?";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (page === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (userId === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (userId !== undefined)
            url_ = url_.replace("{userId}", userId);
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBooks(_response);
        });
    }

    protected processGetBooks(response: Response): Promise<GetBooksResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                const jsonData = _responseText?JSON.parse(_responseText):{}
                result200 = _responseText === "" ? null : <GetBooksResult>JSON.parse(JSON.stringify(jsonData.data), this.jsonParseReviver);
                
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetBooksResult>(<any>null);
    }

    /**
     * Upload file
     * @return successful operation
     */
    uploadFile(body: FormData,bookId: string): Promise<UploadFileResult> {
        let url_ = this.baseUrl + "/admin/book-recommends/{recommend_book_id}/cover";
        url_ = url_.replace("{recommend_book_id}", bookId)
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            body: body,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadFile(_response);
        });
    }

    protected processUploadFile(response: Response): Promise<UploadFileResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <UploadFileResult>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === "" ? null : <UploadFileResult>JSON.parse(_responseText, this.jsonParseReviver);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UploadFileResult>(<any>null);
    }
}

export interface GetTop10BooksResult {
    data: Book[];
}

export interface GetActiveCodesPercentResult {
    current: number;
    total: number;
    percentage: number;
}

export interface GetBookWithHighestActiveCodesResult {
    activeCodes: number;
    createdCodes: number;
    activeCodesPercent: number;
    book: Book;
}



export interface ExportExcelResult {
    filename: string;
}

export interface CheckCreateCodesResult {
    createdCodes: number;
    runningJob: any;
}

export interface FindAccessCodesResult {
    content: Book[];
    total_pages: number;
    total_items: number;
    page_number: number;
    page_size: number;
}

export interface LoginResult {
    token: string;
    user: User;
}

export interface TokenResult {
    token: string;
}
export interface MessageResult {
    message: string;
}
export interface CreateAccessCodeResult {
    accessCodes: AccessCode[];
}

export interface CreateAccessCodeBody {
    book_id: string;
    amount: number;
}

export interface SubmitAccessCodeBody {
    code: string;
    
}

export interface AccessCode {
    id: string,
    code: string,
    grade: string,
    bookType: string,
    created_at: number,
    updated_at: number,
    active_date: string,
    is_activated: boolean
}

export interface UpdateLastLoginBody {
}

export interface UpdatephoneResult {
    customToken: string;
}

export interface UpdatephonePayload {
    operation: UpdatephonePayloadOperation;
    payload: Payload;
}

export interface ChangephoneBody {
    email: string;
    newphone: string;
    newCountryCode: string;
    newLineNumber: string;
    newPassword: string;
    authorizeCode: string;
}

export interface CheckphoneExistResult {
    phoneExist: boolean;
}

export interface CheckEmailExistResult {
    emailExist: boolean;
}

export interface GetAllRolesResult {
    roles: Role[];
}

export interface CheckRoleNameExistResult {
    roleNameExist: boolean;
}

export interface FindPermissionsResult {
}

export interface LoginUserPayload {
    username: string;
    password: string;
}
export interface LoginAdminUserPayload {
    email: string;
    password: string;
}
export interface UserForgotPasswordPayload {
    username: string;
    callback_url: string;
}
export interface UserForgotPasswordPayloadSMS {
    username: string;
}
export interface UserChangePasswordPayload {
    username: string;
    new_password: string;
    token: string;
}

export interface UserChangePasswordPayloadSMS {
    username: string;
    new_password: string;
    otp: string;
}
export interface RegisterUserPayload {
    username: string;
    password: string;
    name: string;
    email: string;
    phone: string;
    address: string;
    school: string;
    callback_url: string;
}

export interface FindRolesResult {
    data: Role[];
    before: string;
    after: string;
}

export interface ActivateRolePayload {
    operation: ActivateRolePayloadOperation;
}

export interface DeactivateRolePayload {
    operation: DeactivateRolePayloadOperation;
}

export interface UpdateRolePayload {
    operation: UpdateRolePayloadOperation;
    payload: Payload2;
}

export interface Role {
    id: string;
    name: string;
    description: string;
    isActive: any;
    permissions: string[];
}

export interface CreateRolePayload {
    name: string;
    description: string;
    permissions: string[];
}

export interface FindUsersResult {
    content: User[];
    total_pages: number;
    total_items: number;
    page_number: number;
    page_size: number;
}

export interface UserAddress {
    school: string;
    detail: string;
    ward: Ward;
    district: District2;
    province: Province2;
}

export interface User {
    id: string;
    username: string;
    name: string;
    address: string;
    role: string;
    picture_url: string;
    email: string;
    isActive: boolean;
    created_at: number;
    enabled: boolean;
    updated_at: number;
}

export interface UpdateUserPayload {
    password: string;
    sizeName?: string;
    name: string;
    phone: string;
    address: string;
}

export interface ChangePasswordPayload {
    newPassword: string;
}

export interface UpdateProfilePayload {
    operation: UpdateProfilePayloadOperation;
    payload: Payload3;
}

export interface ActivateUserPayload {
    operation: ActivateUserPayloadOperation;
}

export interface DeactivateUserPayload {
    operation: DeactivateUserPayloadOperation;
}

export interface UpdateAvatarPayload {
    operation: UpdateAvatarPayloadOperation;
    payload: Payload4;
}

export interface CreateUserPayload {
    phone: string;
    countryCode: string;
    lineNumber: string;
    password: string;
    roles: string[];
    fullName: string;
}

export interface GetBooksResult {
    content: Book[];
    data: Book[];
    total_pages: number;
    total_items: number;
    page_number: number;
    page_size: number;
}

export interface Book {
    id: string;
    title: string;
    shortName: string;
    type: BookType;
    grade: number;
    book_id: string;
    book_code: AccessCode;
    cover_url: string;
    description:string;
    creator: Creator;
    createdCodes: number;
    activeCodes: number;
    hasAccessCode: boolean;
    createdAt: number;
    lastModifiedAt: number;
    book_content: any;
}
export interface BookRecommend {
    id: string;
    title: string;
    admin_book_id: string;
    creator: Creator;
}

export interface Creator {
    id: string,
    email: string,
    name: string
}
export interface UpdateBookBody {
    name: string;
    shortName: string;
    type: UpdateBookBodytype;
    grade: number;
    smallThumbnail: string;
    mediumThumbnail: string;
    largeThumbnail: string;
    url: string;
}

export interface CreateBookBody {
    title: string;
    short_name: string; 
    category: BookType;
    grade: number;
    book_id: string;
    // type: string
}

export interface CreateRecommendBookBody {
    title: string;
    admin_book_id: string;
    id?: string;
}

export interface UploadFilePayload {
    uri: any;
}

export interface UploadFileResult {
    name: string;
    url: string;
    size: number;
}

export interface Body {
}

export interface Body2 {
}

export enum UpdatephonePayloadOperation {
    Updatephone = "updatephone",
}

export interface Payload {
    newphone: string;
    newCountryCode: string;
    newLineNumber: string;
}

export enum ActivateRolePayloadOperation {
    Activate = "activate",
}

export enum DeactivateRolePayloadOperation {
    Deactivate = "deactivate",
}

export enum UpdateRolePayloadOperation {
    UpdateDetail = "updateDetail",
}

export interface Payload2 {
    name: string;
    description: string;
    permissions: string[];
}

export interface Ward {
    value: number;
    label: string;
    fatherId: number;
}

export interface District2 {
    value: number;
    label: string;
    fatherId: number;
}

export interface Province2 {
    value: number;
    label: string;
}

export enum UpdateProfilePayloadOperation {
    UpdateDetail = "updateDetail",
}

export interface Payload3 {
    fullName: string;
    dob: number;
    gender: Payload3Gender;
    email: string;
    address: UserAddress;
}

export enum ActivateUserPayloadOperation {
    Activate = "activate",
}

export enum DeactivateUserPayloadOperation {
    Deactivate = "deactivate",
}

export enum UpdateAvatarPayloadOperation {
    UpdateAvatar = "updateAvatar",
}

export interface Payload4 {
    picture_url: string;
}

export enum BookType {
    REFERENCE_BOOK = "REFERENCE_BOOK",
    TEXT_BOOK = "TEXT_BOOK",
}

export interface cover_url {
    small: string;
    medium: string;
    large: string;
}

export enum UpdateBookBodytype {
    REFERENCE_BOOK = "REFERENCE_BOOK",
    TEXT_BOOK = "TEXT_BOOK",
}

export enum CreateBookBodytype {
    REFERENCE_BOOK = "REFERENCE_BOOK",
    TEXT_BOOK = "TEXT_BOOK",
}

export enum Payload3Gender {
    MALE = "MALE",
    FEMALE = "FEMALE",
    OTHER = "OTHER",
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

export { };